/**
 * createToySlice.ts
 * Any state related to the physical toy or its augmented reality experience
 */

import { StoreSlice } from "../types";

export declare interface IToySliceProps {
  showScanConfirmationScreen: boolean;
  toyOnScreenLayout: boolean;
}

export declare interface IToySliceSetters {
  setShowScanConfirmationScreen: (v: boolean) => void;
  toggleScanConfirmationScreen: () => void;
  setToyOnScreenLayout: () => void;
}

export declare type IToySlice = IToySliceProps & IToySliceSetters;

const createToySlice: StoreSlice<IToySliceProps, IToySliceSetters> = (
  set
) => ({
  showScanConfirmationScreen: false,
  toyOnScreenLayout: false,
  setShowScanConfirmationScreen: (v) =>
    set((state) => {
      state.showScanConfirmationScreen = v;
    }),
  toggleScanConfirmationScreen: () => set((state) => ({ showScanConfirmationScreen: !state.showScanConfirmationScreen })),
  setToyOnScreenLayout: (v) =>
  set((state) => {
    state.toyOnScreenLayout = v;
  }),
});

export default createToySlice;
